import {
  Person,
  PersonFilters,
  PersonFiltersTranslator,
  PersonSortingOptionsConsts,
  personsConstants,
} from "../../../api/Person";
import { CustomTypeLabelRenderer } from "../../../Customization/CustomTypes/generics/CustomTypeRenderer";
import { EntityStateIndicator } from "../../badges/EntityStateIndicator/EntityStateIndicator";
import { DateTimeRenderer } from "../../datetime/DateTimeFormatter";

import { NotAvailable, NotSet } from "../../misc/UIconstants";
import { EntitySidebarTile, EntitySidebarTileProps } from "./EntitySidebarTile/EntitySidebarTile";

export const PersonsTile = (props: EntitySidebarTileProps<Person, PersonFilters>) => (
  <EntitySidebarTile<Person, PersonFilters>
    {...props}
    entityConstants={personsConstants}
    orderByOptions={PersonSortingOptionsConsts}
    translatorConsts={PersonFiltersTranslator}
    defaultFilters={{ sortBy: [{ property: "LAST_NAME", sortDirection: "DESC" }], ...props.defaultFilters }}
    rowLabel={(e) => (
      <div className="ellipsisContainer">
        <span>{e.name || NotAvailable}</span>
        <EntityStateIndicator entityConstants={personsConstants} entity={e} hideLabels />
      </div>
    )}
    rowDate={(e) => <DateTimeRenderer date={e.enteredOn} includeTime={false} includeDate={true} />}
    rowInfo={(e) => <>{e.email || NotSet}</>}
    rowId={(e) => <CustomTypeLabelRenderer entity={e} />}
  />
);
